var _ = require('underscore/underscore');
var BasePopup = require('front/components/BasePopup/BasePopup');

var template = require('./GuildPopup.jinja');
require('./GuildPopup.less');

var CommonStory = require('front/components/CommonStory/CommonStory');
var CommonFooterMembership = require('front/components/CommonFooterMembership/CommonFooterMembership');

module.exports = BasePopup.extend({

    template: template,

    //Base creates an instances for each one of found dom nodes (by selector) when parent view is rendered itself
    VIEWS_TO_REGISTER: {
        'CommonStory': {selector: '.CommonStory', viewConstructor: CommonStory},
        'CommonFooterMembership': {selector: '.CommonFooterMembership', viewConstructor: CommonFooterMembership}
    },

    events: _.extend({

    }, BasePopup.prototype.baseEvents),


    apiUrl: function () {
        return Urls['front:api:guild-popup']('json');
    },

    renderData: function () {
        return {
            popup: this.data || {}
        };
    },

    initialize: function (options) {
        this.options = options || {};

        BasePopup.prototype.initialize.call(this, options);
    },


    activate: function () {
        return BasePopup.prototype.activate.call(this);
    },


    deactivate: function (params) {
        return BasePopup.prototype.deactivate.call(this, params);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/GuildPopup/GuildPopup.js
// module id = 273
// module chunks = 0